import { Close } from "@mui/icons-material"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, NativeSelect, Switch, TextField, Typography } from "@mui/material"
import { useForm } from "react-hook-form"
import withShowAlert from "components/withShowAlert"
import { useState } from "react"
import { LoadingButton } from "@mui/lab"
import { create, update } from "api/usersApi"

function FormDialog({ open, setOpen, editingModel, showAlert }) {

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showPassword, setShowPassword] = useState(editingModel?.id == null ? true : false)

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    }

    setOpen(false)
  }

  const getErrorMessage = (field) => {
    if (errors[field]) {
      return errors[field].message
    }
    return undefined
  }

  const submitForm = async (data) => {
    setIsSubmitting(true)

    const body = {
      email: data.email?.toLowerCase(),
      password: showPassword ? data.password : undefined,
      role: data.role
    }

    try {
      editingModel?.id ? await update(editingModel.id, body) : await create(body)
      const message = editingModel?.id ? 'Atualizado com sucesso.' : 'Criado com sucesso.'
      setOpen(false, true, message)
    } catch (error) {
      const errorData = error.response?.data?.message?.join("\n") || "Erro desconhecido, entre em contato com o suporte."
      showAlert(errorData, 'error')
    }

    setIsSubmitting(false)
  }

  return <Dialog
    fullWidth={true}
    maxWidth="md"
    open={open}
    onClose={handleClose}>

    <DialogTitle mb={2}>
      <Typography variant={"h4"}>
        {editingModel?.id == null ? "Nova credencial" : 'Editar credencial'}
      </Typography>
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <Close />
      </IconButton>
    </DialogTitle>

    <DialogContent>
      <form id="offer-form" onSubmit={handleSubmit(submitForm)}>
        <Grid container mt={1} spacing={2}>
          <Grid item xs={12}>
            <TextField
              {...register("email")}
              error={getErrorMessage("email")}
              helperText={getErrorMessage("email")}
              sx={{ maxWidth: "none", width: "100%" }}
              id="email"
              type="email"
              name="email"
              label="E-mail"
              defaultValue={editingModel?.email}
              variant="outlined"
            />
          </Grid>
        </Grid>
        <Grid container mt={1} spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="standard">
              <InputLabel variant="standard" htmlFor="role">Nível</InputLabel>
              <NativeSelect
                defaultValue={editingModel?.role}
                {...register('role', { required: true })}
                inputProps={{
                  name: 'role',
                  id: 'role'
                }}

                label="Nível"
              >
                <option value="admin">Admin</option>
                <option value="super_admin">Super Admin</option>
              </NativeSelect>
            </FormControl>
          </Grid>
        </Grid>
        {
          editingModel?.id &&
          <Grid container mt={1} spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showPassword}
                    onChange={(e) => setShowPassword(e.target.checked)}
                  />
                }
                label={"Alterar senha?"}
                size="small" />
            </Grid>
          </Grid>
        }

        {showPassword &&

          <Grid container mt={1} spacing={2}>
            <Grid item xs={6}>
              <TextField
                {...register("password", { required: true })}
                error={getErrorMessage("password")}
                helperText={getErrorMessage("password")}
                sx={{ maxWidth: "none", width: "100%" }}
                id="password"
                type="password"
                name="password"
                label="Senha"
                defaultValue={editingModel?.password}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                {...register("password_confirmation", {
                  required: true, validate: (val) => {
                    if (watch('password') !== val) {
                      return "As senhas não coincidem.";
                    }
                  }
                })}
                error={getErrorMessage("password_confirmation")}
                helperText={getErrorMessage("password_confirmation")}
                sx={{ maxWidth: "none", width: "100%" }}
                id="password_confirmation"
                type="password"
                name="password_confirmation"
                label="Confirmar senha"
                defaultValue={editingModel?.password_confirmation}
                variant="outlined"
              />
            </Grid>
          </Grid>
        }
      </form>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setOpen(false)} color="error" variant="contained">Cancelar</Button>
      <LoadingButton loading={isSubmitting} form="offer-form" type="submit"
        variant="contained">Salvar</LoadingButton>
    </DialogActions>
  </Dialog >
}

export default withShowAlert(FormDialog)